import he from "he"

const decodeHtmlEntities = (html: string): string => {
    const decodedHtml = he.decode(html)
    // const decodedHtml = new DOMParser().parseFromString(html, "text/html").body.textContent
    return decodedHtml ?? html
}

export default decodeHtmlEntities
